import React, { useState, useEffect } from "react";
import { Slider, Box } from "@mui/material";
import "./InvestmentBar.modules.css";
import i18next from "i18next";
import * as Helpers from "../../../../../global/Helpers";
import { useTranslation } from "react-i18next";
import * as Constants from "../../../../../constants/Constants";

const InvestmentBar = (props) => {
  const { t } = useTranslation();
  const [equities, setEquities] = useState(0);
  const [fixedIncome, setFixedIncome] = useState(0);
  const [structuredProducts, setStructuredProducts] = useState(0);

  const handleChange = (setter) => (event, newValue) => {
    setter(newValue);
  };
  const marks = [
    { value: 0, label: "00" },
    { value: 1, label: "1Y" },
    { value: 2, label: "2Y" },
    { value: 3, label: "3Y" },
    { value: 4, label: "4Y" },
    { value: 5, label: ">5Y" },
  ];

  useEffect(() => {
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    if (
      equities === null ||
      equities === "" ||
      fixedIncome === "" ||
      fixedIncome === null ||
      structuredProducts === "" ||
      structuredProducts === null
    ) {
      Helpers.errorNotify(
        t("Please fill Investment Experience Data"),
        i18next.language
      );
      return false;
    } else {
      props.setRequestItemsList([]);
      props.setIsCallAPI(false);
    }
    return true;
  }

  const saveKycDataFun = () => {
    if (!validateSubmit()) return;
    // var Items = [
    //     // { ID: "", Value: equities },
    //     { ID: "171", Value: fixedIncome },
    //     { ID: "172", Value: structuredProducts }
    // ]

    var arr = props.RequestItemsList;
    arr.push({ ID: "141", Value: equities + 1 });
    arr.push({ ID: "229", Value: fixedIncome + 1 });
    arr.push({ ID: "230", Value: structuredProducts + 1 });
    props.setRequestItemsList(arr);
    // props.setIsCallAPIOnce(true);
    // props.saveKycDataAPI(Items);
  };

  return (
    <div className="InvestmentBar">
      <Box sx={{ width: "100%", margin: "0 auto", padding: "10px" }}>
        <h2> {props.title} </h2>
        <Box sx={{ marginBottom: "0px" }}>
          <label>{t("EquitiesandRelatedSecurities")}</label>
          <Slider
            value={equities}
            onChange={handleChange(setEquities)}
            step={1}
            marks={marks}
            min={0}
            max={5}
            valueLabelDisplay="auto"
            label={"30-35 min"}
            //   defaultValue={0}
            valueLabelFormat={(value) => (value > 0 ? `${value}Y` : "00")}
            sx={{ width: "100%" }}
            color= "#0b1d81"
          />
        </Box>

        <Box sx={{ marginBottom: "0px" }}>
          <label variant="subtitle1">{t("FixedIncome")}</label>
          <Slider
            value={fixedIncome}
            onChange={handleChange(setFixedIncome)}
            step={1}
            marks={marks}
            min={0}
            max={5}
            valueLabelDisplay="auto"
            //   defaultValue={0}
            valueLabelFormat={(value) => (value > 0 ? `${value}Y` : "00")}
            sx={{ width: "100%" }}
            color= "#0b1d81"
            
          />
        </Box>

        <Box>
          <label variant="subtitle1">{t("structured_product")}</label>
          <Slider
            value={structuredProducts}
            onChange={handleChange(setStructuredProducts)}
            step={1}
            marks={marks}
            min={0}
            max={5}
            valueLabelDisplay="auto"
            //   defaultValue={0}
            valueLabelFormat={(value) => (value > 0 ? `${value}Y` : "00")}
            sx={{ width: "100%" }}
             color= "#0b1d81"
          />
        </Box>
      </Box>
    </div>
  );
};

export default InvestmentBar;
